import React from 'react';
import moment from 'moment';
import { Text, TextColor } from '../../Text';
import { isToday } from '../../Utils';
import './CalendarDayHeader.css';

export interface DayHeaderProps {
  date: Date;
  currentView: string;
}

export const getDayHeaderFontColor = (date: Date): TextColor =>
  isToday(date) ? 'primary' : 'secondary';

/**
 * Renders the calendar table header for week and day view
 */
export const CalendarDayHeader: React.FC<DayHeaderProps> = ({ date, currentView }) => (
  <>
    {currentView !== 'dayGridMonth' && (
      <Text color={getDayHeaderFontColor(date)} weight="bold" className="calendarDayHeader-date">
        {moment(date, 'YYYY-MM-DD[T]h:mmAZ').format('DD.MM.')}
      </Text>
    )}
    <div>
      <Text
        color={getDayHeaderFontColor(date)}
        size="sm"
        weight={currentView === 'dayGridMonth' ? 'bold' : 'normal'}
      >
        {moment(date, 'YYYY-MM-DD[T]h:mmAZ').format('dddd')}
      </Text>
    </div>
  </>
);
